import { render, staticRenderFns } from "./SidebarCartAdditionalProducts.vue?vue&type=template&id=6bb65d98&"
import script from "./SidebarCartAdditionalProducts.vue?vue&type=script&lang=js&"
export * from "./SidebarCartAdditionalProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/guave/madamesumcontao/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb65d98')) {
      api.createRecord('6bb65d98', component.options)
    } else {
      api.reload('6bb65d98', component.options)
    }
    module.hot.accept("./SidebarCartAdditionalProducts.vue?vue&type=template&id=6bb65d98&", function () {
      api.rerender('6bb65d98', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/madamesum/js/components/SidebarCartAdditionalProducts.vue"
export default component.exports